module.exports = __webpack_public_path__ + "img/svea.72a0509.png";